import styled from 'styled-components';

export const Content = styled.div`
  text-align: left;

  .status-list {
    display: grid;
    grid-template-columns: minmax(0, 1fr);
    @media (min-width: 768px) {
      grid-template-columns: repeat(2, minmax(0, 1fr));
    }
    column-gap: 24px;
  }
`;
